import { Helmet } from "react-helmet-async";

export default function MetuZemelapisSoon() {
  return (
    <div className="min-h-screen bg-cream px-5 py-24 md:py-36">
      <Helmet>
        <title>Metų žemėlapis</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <section className="mx-auto max-w-2xl text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Laimės Dieta</p>
        <h1 className="mt-6 font-serif text-5xl md:text-7xl">Metų žemėlapis</h1>
        <p className="mt-6 text-lg text-muted-foreground">Ruošiame. Netrukus.</p>
        <a href="https://www.laimesdieta.lt/" className="mt-10 inline-block text-sm underline underline-offset-4">laimesdieta.lt</a>
      </section>
    </div>
  );
}
